import React from "react";

import { Dialog } from "@natera/material/lib/dialog";
import { defineMessages, useIntl } from "react-intl";
import { ConfigContext } from "@app/provider";
import { Link } from "@natera/navigation";

import "./balanceProcessingDialog.scss";

const messages = defineMessages({
  balanceProcessingDialogHeader: {
    id: "balanceProcessingDialogHeader",
    defaultMessage: "Why is a portion of my balance still processing?",
  },
  balanceProcessingDialogParagraph1: {
    id: "balanceProcessingDialogParagraph1",
    defaultMessage:
      "When we bill your insurance for a test, we may include multiple CPT codes. These are individual billing codes tied to the different parts of the test. Sometimes, your insurance reviews and processes those codes at different times—even if they're all from the same test.",
  },
  balanceProcessingDialogParagraph2: {
    id: "balanceProcessingDialogParagraph2",
    defaultMessage:
      "As we hear back from your insurance about each CPT code, we get confirmation on how much they're covering and what portion, if any, is your responsibility. Based on that, we may send you updated billing statements as that information becomes available.",
  },
  balanceProcessingDialogParagraph3: {
    id: "balanceProcessingDialogParagraph3",
    defaultMessage:
      "This means the amount you see may update if your insurance processes additional parts of the claim later on. We know this can be confusing, but it's part of how insurers review and split up coverage when there are multiple components to a test. We'll notify you once the remaining amount is confirmed. If you have any questions, {contactUs}",
  },
  balanceProcessingDialogContactUs: {
    id: "balanceProcessingDialogContactUs",
    defaultMessage: "contact us.",
  },
});

type BalanceProcessingProps = {
  onCloseDialog: () => void;
};

const BalanceProcessingDialog: React.FC<BalanceProcessingProps> = ({
  onCloseDialog,
}) => {
  const intl = useIntl();
  const { config } = React.useContext(ConfigContext);

  return (
    <Dialog
      className="balance-processing-modal"
      onClose={onCloseDialog}
      showCrossButton
      title={intl.formatMessage(messages.balanceProcessingDialogHeader)}
    >
      <div className="balance-processing-modal__container">
        <p>{intl.formatMessage(messages.balanceProcessingDialogParagraph1)}</p>
        <p>{intl.formatMessage(messages.balanceProcessingDialogParagraph2)}</p>
        <p>
          {intl.formatMessage(messages.balanceProcessingDialogParagraph3, {
            contactUs: (
              <Link
                target="_blank"
                key="privacyPolicy"
                rel="noopener noreferrer"
                to={config.links.CONTACT_US}
              >
                {intl.formatMessage(messages.balanceProcessingDialogContactUs)}
              </Link>
            ),
          })}
        </p>
      </div>
    </Dialog>
  );
};

export default BalanceProcessingDialog;
